import React, { useMemo } from "react";
import { chunk } from "lodash";
import { useAssetTypeAttributes } from "../../../../common/hooks";
import GridColumn from "../GridColumn";

const CHUNK_SIZE = 2;

type Props = {
    assetTypeId: number,
    attributes: Array<any>
};

/**
 * Asset Attributes Component
 */
export default ({ assetTypeId, attributes }: Props) => {
    const assetTypeAttributes = useAssetTypeAttributes(assetTypeId || 0);

    const rows = useMemo(() => {
        return chunk(attributes, CHUNK_SIZE);
    }, [attributes]);

    return rows.map(([first, second], index) => (
        <React.Fragment key={index}>
            {first.value && first.value.toLowerCase() !== "none" && (
                <GridColumn
                    label={assetTypeAttributes[first.attribute]}
                    value={first.value}
                />
            )}

            {second &&
                second.value &&
                second.value.toLowerCase() !== "none" && (
                    <GridColumn
                        label={assetTypeAttributes[second.attribute]}
                        value={second.value}
                    />
                )}
        </React.Fragment>
    ));
};
